import { useQuery } from "@tanstack/react-query";
import { toastServerError } from "helpers";
import {
  ApiError,
  ApiServiceError,
  GetListRequestParams,
  GetListResponse
} from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import { NotificationsListItem } from "../../notifications.types";
import { requestGetNotifications } from "./getNotifications.request";

const useGetNotifications = (
  requestParams: GetListRequestParams,
  options?: QueryOptions<
    GetListResponse<NotificationsListItem>,
    ApiServiceError<ApiError>
  >
) => {
  const { data, ...rest } = useQuery({
    queryKey: ["notification", "admin", "all", requestParams],
    queryFn: async () => await requestGetNotifications(requestParams),
    onError: toastServerError,
    ...options
  });

  return { notifications: data?.data, meta: data?.meta, ...rest };
};

export default useGetNotifications;
